<template>
  <div>
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>STOK KAYIT EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item">
            <a href="#">STOK KAYIT EKRANI</a>
          </li>
        </ul>
      </div>
      <div class="row form-margin">
        <div class="col-lg-12 col-md-12 tex-center d-flex align-items-center flex-column">
          <div class="tile">
            <h3 class="tile-title">STOK KAYIT EKRANI</h3>

            <div class="tile-body">
              <form>
                <div id="app">
                  <label class="control-label"
                    >Stok Girilecek Sahayı Seçiniz</label
                  >
                  <select class="form-control" @change="getBySaha($event)">
                    <option value="" selected disabled>SAHA SEÇİNİZ</option>
                     <option
                      v-if="saha.status == 0"
                      v-for="saha in sahalar"
                      :value="saha.id"
                      :key="saha.id"
                      >{{ saha.id }} - {{ saha.sahaName }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label">Ürün Seçiniz</label>
                  <select class="form-control" @change="getByCategory($event)">
                    <option value="" selected disabled>Ürün Seçiniz</option>
                    <option
                      v-for="category in categories"
                      :value="category.id"
                      :key="category.id"
                      >{{ category.product_name }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label">Durum Seçiniz</label>
                  <select class="form-control" @change="getByStatu($event)">
                    <option value="" selected disabled>Durum Seçiniz</option>
                    <option
                      v-for="statu in status"
                      :value="statu.id"
                      :key="statu.id"
                      >{{ statu.statu_name }}</option
                    >
                  </select>
                </div>
                <div id="app">
                  <label class="control-label">Personel Seçiniz</label>
                  <select class="form-control" @change="getByPersonel($event)">
                    <option value="" selected disabled>Personel Seçiniz</option>
                    <option
                      v-for="personel in personeller"
                      :value="personel.id"
                      :key="personel.id"
                      >{{ personel.name }} {{ personel.surname }}</option
                    >
                  </select>
                </div>
                <label class="control-label">Makina Seçiniz</label>
                <select class="form-control" @change="changemakina($event)">
                  <option value="" selected disabled>MAKİNA SEÇİNİZ</option>
                  <option
                    v-for="machine in machines"
                    :value="machine.id"
                    :key="machine.id"
                    >{{
                      machine.makina_code + " " + machine.makina_name
                    }}</option
                  >
                </select>
                <div class="form-group">
                  <label class="control-label">Adet Giriniz</label>
                  <input
                    v-model="gidertutari"
                    class="form-control"
                    type="number"
                    placeholder="Adet Giriniz"
                  />
                </div>
                <div class="form-group">
               <label class="control-label">Stok Kayıt Tarihi</label>
                  <input
                    class="form-control"
              
                    v-model="gidertarihi"
                    type="date"
                    id="start"
                    name="trip-start"
                    min="2023-09-27"
                    max="2030-12-31"
                  />
                </div>
           
                <div class="form-group">
                  <label class="control-label">Açıklama</label>
                  <input
                    v-model="aciklamaone"
                    class="form-control"
                    type="text"
                    placeholder="Açıklama"
                  />
                </div>
              </form>
            </div>

            <div class="tile-footer">
              <button @click="sendData()" class="btn btn-primary" type="button">
                <i class="fa fa-fw fa-lg fa-check-circle"></i>Kaydet
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      sahalar: [],
      machines: [],
      categories: [],
      personeller: [],
      status: [{id:0,statu_name:"SAHA GİRİŞ"},{id:1,statu_name:"SAHA ÇIKIŞ"},{id:2,statu_name:"DEĞİŞEN-KIRILAN PARÇA"},],
      gidertutari: "",
      gidertarihi: "",
      aciklamaone: "",
      aciklamatwo: "",
      makineId: "",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getAllSahaDropUpdate.php?key=123";
    axios
      .post(url)
      .then((response) => {
        this.sahalar = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url2 =
      store.state.base_url + "AslanSahalar/getAllStokCategory.php?key=123";
    axios
      .post(url2)
      .then((response2) => {
        this.categories = response2.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
      var url7 = store.state.base_url + "AslanSahalar/getAllMakinaFilter.php?key=123";
    axios
      .post(url7)
      .then((response) => {
        this.machines = response.data;
      })
      .catch((err) => {
        console.log(err.response);
      });
    var url3 = store.state.base_url + "AslanSahalar/getAllPersonelStatus.php?key=123";
    axios
      .post(url3)
      .then((response3) => {
        this.personeller = response3.data;
   //     console.log(response3.data);
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  methods: {
    changemakina(event) {
      this.makineId = event.target.value;
    },
    getBySaha(event) {
      var saha_id = event.target.value;
      this.saha_id = saha_id;
      // var datas = { saha_id };
      // var urlm = store.state.base_url + "AslanSahalar/getAllMakinaSaha.php?key=123";
      // axios
      // .post(urlm, JSON.stringify(datas))
      //   .then((response) => {
      //     this.machines = response.data;
      //   })
      //   .catch((err) => {
      //     console.log(err.response);
      //   });
    },
    getByCategory(event) {
      var category_id = event.target.value;
      this.category_id = category_id;
    },
    getByStatu(event) {
      var statu_id = event.target.value;
      this.statu_id = statu_id;
    },
    getByPersonel(event) {
      var personel_id = event.target.value;
      this.personel_id = personel_id;
    },
    reload: function() {
      location.reload();
    },
    sendData: function() {
      if (this.gidertarihi == "") {
        this.$swal({
          text: "GİDER TARİHİNİ GİRİNİZ!",
          icon: "error",
          closeOnClickOutside: false,
        });
      } else {
        var url = store.state.base_url + "AslanSahalar/createStokLog.php?key=123";
        var datas = {
          id: localStorage.getItem("id"),
          token: localStorage.getItem("token"),
          stoktarihi: this.gidertarihi,
          product_id: this.category_id,
          saha_id: this.saha_id,
          aciklama: this.aciklamaone,
          personel_id: this.personel_id,
          adet: this.gidertutari,
          makineId: this.makineId,
          status: this.statu_id,
          // deneme

        };
        console.log(this.saha_id)

        axios
          .post(url, JSON.stringify(datas))
          .then((response) => {
            if (response.data.data == true) {
              this.$swal({
                text: "Kayıt İşleminiz Başarıyla Gerçekleştirildi!",
                icon: "success",
                closeOnClickOutside: true,
              });
              
            } else {
              this.$swal({
                text: "Hata Oluştu Admine Danışın!",
                icon: "error",
                closeOnClickOutside: false,
              });
            }

            ////conso.log(response);
          })
          .catch((error) => {
            //conso.log(error.response);
          });
      }
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/StokKayit.vue